import React from 'react';
import { Clock, Archive, Users, RefreshCw } from 'lucide-react';
const pillars = [{
  icon: Clock,
  color: '#DC2626',
  title: 'Memory cannot wait',
  body: 'Regimes rely on oblivion. Every year that passes without documenting what happened is a victory for those who destroyed Venezuela. This book is an act of resistance.'
}, {
  icon: Archive,
  color: '#d4a85a',
  title: 'Leaving a record for history',
  body: 'Future generations need to know what really happened. Not the official version, nor the convenient narrative—but the raw, documented truth of what the Venezuelan people endured.'
}, {
  icon: Users,
  color: '#2563eb',
  title: 'A message to new generations',
  body: 'The children of the diaspora are growing up without fully understanding why their parents cried when talking about their country. This book gives them answers. It returns their history to them.'
}, {
  icon: RefreshCw,
  color: '#f59e0b',
  title: 'The end of a political cycle',
  body: 'We are at a historic turning point. Understanding how we got here is the first step toward building what comes next. Venezuela has a future—but that future needs to know its past.'
}];
export function FourReasons() {
  return <section className="bg-[#0a0a0a] py-12 sm:py-20 px-6 border-t border-gray-900/60" data-id="element-95">
      <div className="max-w-5xl mx-auto" data-id="element-96">
        {/* Header */}
        <div className="text-center mb-16 flex flex-col items-center gap-6" data-id="element-97">
          <p className="text-[#d4a85a] uppercase tracking-[0.25em] text-[11px] sm:text-xs font-semibold" data-id="element-98">
            The Moment Is Now
          </p>

          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#e8e2d4] font-normal leading-tight" data-id="element-99">
            Four reasons why you cannot wait
          </h2>

          {/* Red-blue-gold divider */}
          <div className="h-px w-32" style={{
          background: 'linear-gradient(to right, #DC2626, #2563eb, #d4a85a)'
        }} data-id="element-100" />
        </div>

        {/* 2-column grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-10" data-id="element-101">
          {pillars.map(p => <div key={p.title} className="flex gap-5 sm:gap-6" data-id="element-102">
              {/* Circular filled icon */}
              <div className="w-14 h-14 rounded-full flex items-center justify-center flex-shrink-0" style={{
            backgroundColor: p.color,
            boxShadow: `0 0 24px ${p.color}40`
          }} data-id="element-103">
                <p.icon className="w-6 h-6 text-white" strokeWidth={2} data-id="element-104" />
              </div>

              {/* Text content */}
              <div className="flex flex-col gap-3 pt-1" data-id="element-105">
                <h3 className="font-serif text-xl sm:text-[22px] text-[#e8e2d4] font-semibold leading-snug" data-id="element-106">
                  {p.title}
                </h3>
                <p className="font-serif text-gray-400 text-[15px] sm:text-base leading-[1.7] font-light" data-id="element-107">
                  {p.body}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}